const idOf = (record) => String(record?.id ?? record?.hs_object_id ?? '').trim()

// Only a current member supplied by the scoped book can be selected. No default
// seed, parent owner, saved stale object, or synthetic summary can become a target.
export function selectedMemberRow(summary, selectedId) {
  if (!summary?.isIndyGroup || !selectedId) return null
  const matches = (summary.memberRecords || []).filter((record) => idOf(record) === String(selectedId))
  if (matches.length !== 1 || matches[0].isIndyGroup || idOf(matches[0]).startsWith('indy:')) return null
  const record = matches[0]
  return { id: idOf(record), name: record.name || idOf(record), record }
}
